import { LoanType } from '@apply/constants';
import * as Store from '@apply/store';
import { Question, QuestionType, PageQuestionProps } from '@apply/ui';
import { connect } from 'react-redux';

export interface OnsitePropertyContactPageQuestionProps extends PageQuestionProps {
    loanType: LoanType;
    contact: Store.BorrowerStore.Types.PrincipalInfo;
    onChangeOnsitePropertyContact?: (guid: string, value: Record<string, unknown>) => void;
}

const OnsitePropertyContact: React.FC<OnsitePropertyContactPageQuestionProps> = ({
    onQuestionValidate,
    submitted,
    property,
    loanType,
    contact,
    onChangeOnsitePropertyContact,
    required,
}) => {
    return (
        <div className='form-group'>
            <div className='row'>
                <Question
                    type={QuestionType.YesNo}
                    submitted={submitted}
                    selector='contactIsPrimary'
                    styleName='ungrouped'
                    onQuestionValidate={onQuestionValidate}
                    value={property.nonRental?.contactIsPrimary}
                    onChangeQualifier={property.guid}
                    onChange={(guid: string, contactIsPrimary: boolean) => {
                        onChangeOnsitePropertyContact(guid, {
                            contactIsPrimary,
                            ...contact,
                        });
                    }}
                    required={required}
                >
                    {loanType !== LoanType.BuildRent ? 'Will' : 'While work is being performed, will'}
                    <strong> {Store.BorrowerStore.Types.formatFullName(contact?.name)} </strong>
                    be the onsite property contact?
                </Question>
            </div>
        </div>
    );
};

export const mapStateToProps = (state: Store.ApplyRootStateType) => {
    return {
        property: state.properties.items.find((itm) => itm.guid === state.properties.currentPropertyId),
        loanType: state.borrower.loanType,
        contact: state.borrower.principal,
    };
};

export const mapDispatchToProps = (dispatch: Store.ApplyDispatchType) => {
    const props: {
        onChangeOnsitePropertyContact: (guid: string, value: Record<string, unknown>) => void;
        dispatch: Store.ApplyDispatchType;
    } = {
        onChangeOnsitePropertyContact: (guid: string, value: Record<string, unknown>) =>
            dispatch(Store.PropertiesStore.Actions.updateContactIsPrimary(guid, value)),
        dispatch,
    };
    return props;
};

export default connect(mapStateToProps, mapDispatchToProps)(OnsitePropertyContact);
